import { GET_COUNTRIES, FEATURED_COUNTRIES, COMMISSION_SETTING, GET_COUNTRIES_HOME } from './action';

const initialState = {
  countries: null,
  homeCountries: null,
  featuredCountries: null,
  commissionSetting: null,

};
function countriesReducer(state = initialState, action: { type: any; payload: any; }) {
  switch (action.type) {
    case GET_COUNTRIES:
      return { ...state, countries: action.payload };
    case GET_COUNTRIES_HOME:
      return { ...state, homeCountries: action.payload };
    case FEATURED_COUNTRIES:
      return { ...state, featuredCountries: action.payload };
    case COMMISSION_SETTING:
      return { ...state, commissionSetting: action.payload };
    default:
      return state;
  }
}
export default countriesReducer;
